import { Button, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { X } from "lucide-react";
import {
	type FinancesModalFormModel,
	type FinancesModalInitialValues,
	useFinancesModalForm,
} from "web_myplann/Finances/Forms/useFinancesModalForm";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannFormInput } from "web_myplann/Shared/Components/MyPlannFormInput";

export type CloseProps = {
	name: string;
	amount: string;
};

type Props = {
	onClose: (data?: CloseProps) => void;
	initialValues?: FinancesModalInitialValues;
	editIndex?: number;
};

export const FinancesModal = ({ onClose, initialValues }: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	const { control, handleSubmit } = useFinancesModalForm({
		initialValues,
	});

	const submit = (data: FinancesModalFormModel) => {
		onClose({
			name: data.name,
			amount: data.amount.toString(),
		});
	};

	return (
		<Stack
			bgcolor={theme.palette.common.white}
			width={"100%"}
			borderRadius={theme.radii.lg}
			p={1.6}
		>
			<form onSubmit={handleSubmit(submit)}>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography
						variant="deprecatedH3"
						color={theme.palette.deprecated.grey[900]}
					>
						{t(Resources.Finances.IncomeModal.modalTitle)}
					</Typography>
					<IconButton onClick={() => onClose()}>
						<X color={theme.palette.deprecated.grey[400]} />
					</IconButton>
				</Stack>
				<Stack gap={1.6} py={1.6}>
					<MyPlannFormInput
						control={control}
						name="name"
						label={t(Resources.Finances.IncomeModal.name)}
					/>
					<MyPlannFormInput
						control={control}
						name="amount"
						label={t(Resources.Finances.IncomeModal.amount)}
						type="integer"
						slotProps={{
							input: {
								endAdornment: (
									<Typography
										variant="deprecatedBody1"
										color={theme.palette.deprecated.grey[500]}
									>
										{t(Resources.Common.CurrencySign)}
									</Typography>
								),
							},
						}}
					/>
				</Stack>
				<Button variant="contained" color="primary" type="submit" fullWidth>
					{t(Resources.Common.save)}
				</Button>
			</form>
		</Stack>
	);
};
